import React, { memo, useContext } from 'react';
import { StyleSheet, css } from 'aphrodite';
import './css/HomePage1Section1.css';
import HomePage1FeatureImagesCarousel1 from '../uiElements/homePage1FeatureImagesCarousels/homePage1FeatureImagesCarousel1/HomePage1FeatureImagesCarousel1';
import { context } from '../../../../globalState/GlobalState';
import { isValidString } from '../../../../catalog/Validity';
import HomePage1Articles4 from '../uiElements/homePage1Articles/homePage1Articles4/HomePage1Articles4';
import HomePage1Articles1 from '../uiElements/homePage1Articles/homePage1Articles1/HomePage1Articles1';

const HomePage1Section1 = () => {
    const { globalState } = useContext(context);

    const styles = StyleSheet.create({
        container: {
            boxShadow: `15px 15px 1px ${isValidString(globalState.websiteStyles.colors.secondaryColor) ? globalState.websiteStyles.colors.secondaryColor : globalState.websiteStyles.colors.primaryColor}`,
            '@media (max-width: 1200px)': {
                boxShadow: `0px 15px 1px ${isValidString(globalState.websiteStyles.colors.secondaryColor) ? globalState.websiteStyles.colors.secondaryColor : globalState.websiteStyles.colors.primaryColor}`,
            },
        },
    });

    return (
        <div className={`homepage1-section1-container x-center m-t-20px ${css(styles.container)}`}>
            <HomePage1FeatureImagesCarousel1 />
            <div className="homepage1-section1-desktop">
                <HomePage1Articles4 />
            </div>
            <div className="homepage1-section1-mobile">
                <HomePage1Articles1 />
            </div>
        </div>
    );
};

export default memo(HomePage1Section1);
